export default __webpack_public_path__ + "static/media/cp_geo_kh.2fbda01f.svg";